import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router";
import Heading from "../../../components/Heading";



const EwayUpdate = () => {
  const navigate = useNavigate();
  const ewayHandle = async () => {
    navigate("/lcr-list");
  };

  return (
    <div>
      <div className="eway-update p-2">
        <Heading title="Eway Update" />
        <div className="eway-update-container">No bags to update</div>
        <div className="d-flex flex-end p-1 footer-btn">
          <Button
            htmlType="submit"
            className="btn-style save-btn btn-two"
            onClick={ewayHandle}
          >
            SKIP
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EwayUpdate;
